import regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import Footer from '~components/footer';
import MobileDrawer from '~components/mobile-drawer/lazy';
import MotionBox from '~components/motion/box';
import Navbar from '~components/navbar';
import siteConfig from '~config/site';
import useNProgress from '~hooks/use-nprogress';
import cms from '~lib/cms';
import { MetaContext } from '~store/meta';
import theme from '~theme';
import { ChakraProvider, EASINGS, Flex } from '@chakra-ui/react';
import { AnimatePresence } from 'framer-motion';
import NextApp from 'next/app';
import Head from 'next/head';
import { DefaultSeo, SocialProfileJsonLd } from 'next-seo';
import { renderMetaTags } from 'react-datocms';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Providers = function(props) {
    var children = props.children, meta = props.meta;
    return(/*#__PURE__*/ _jsx(ChakraProvider, {
        resetCSS: true,
        theme: theme,
        children: /*#__PURE__*/ _jsx(MetaContext.Provider, {
            value: meta,
            children: children
        })
    }));
};
var Effects = function(props) {
    var meta = props.meta, router = props.router;
    useNProgress(router);
    return null;
};
var PAGE_TRANSITION_VARIANTS = {
    initial: {
        opacity: 0,
        x: 0,
        y: -8
    },
    enter: {
        duration: 0.2,
        ease: EASINGS.easeOut,
        opacity: 1,
        x: 0,
        y: 0
    },
    exit: {
        duration: 0.1,
        ease: EASINGS.easeIn,
        opacity: 0,
        x: 0,
        y: 8
    }
};
export default function App(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var Component = props.Component, pageProps = props.pageProps, meta = props.meta, router = props.router;
    return(/*#__PURE__*/ _jsxs(Providers, {
        meta: meta,
        children: [
            /*#__PURE__*/ _jsxs(Head, {
                children: [
                    /*#__PURE__*/ _jsx("meta", {
                        content: "width=device-width, initial-scale=1.0",
                        name: "viewport"
                    }),
                    renderMetaTags(meta.site.favicon)
                ]
            }),
            /*#__PURE__*/ _jsx(DefaultSeo, {
                canonical: siteConfig.siteUrl + (router.asPath || ''),
                defaultTitle: (ref = meta.site.seo) === null || ref === void 0 ? void 0 : (ref1 = ref.fallback) === null || ref1 === void 0 ? void 0 : ref1.title,
                description: (ref2 = meta.site.seo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fallback) === null || ref3 === void 0 ? void 0 : ref3.description,
                openGraph: {
                    type: 'website',
                    site_name: (ref4 = meta.site.seo) === null || ref4 === void 0 ? void 0 : ref4.siteName,
                    images: [
                        (ref5 = meta.site.seo) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fallback) === null || ref6 === void 0 ? void 0 : ref6.image
                    ]
                },
                twitter: {
                    cardType: (ref7 = meta.site.seo) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fallback) === null || ref8 === void 0 ? void 0 : ref8.twitterCard,
                    handle: (ref9 = meta.site.seo) === null || ref9 === void 0 ? void 0 : ref9.twitterAccount,
                    site: (ref10 = meta.site.seo) === null || ref10 === void 0 ? void 0 : ref10.twitterAccount
                }
            }),
            /*#__PURE__*/ _jsx(SocialProfileJsonLd, {
                name: (ref11 = meta.site.seo) === null || ref11 === void 0 ? void 0 : ref11.siteName,
                sameAs: Object.values((ref12 = meta.about) === null || ref12 === void 0 ? void 0 : ref12.socials),
                type: "person",
                url: siteConfig.siteUrl
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                flexDir: "column",
                minH: "100vh",
                children: [
                    /*#__PURE__*/ _jsx(Navbar, {}),
                    /*#__PURE__*/ _jsx(AnimatePresence, {
                        exitBeforeEnter: true,
                        children: /*#__PURE__*/ _jsx(MotionBox, {
                            animate: "enter",
                            exit: "exit",
                            flexGrow: 1,
                            initial: "initial",
                            variants: PAGE_TRANSITION_VARIANTS,
                            children: /*#__PURE__*/ _jsx(Component, _objectSpread({}, pageProps))
                        }, router.route)
                    }),
                    /*#__PURE__*/ _jsx(Footer, {}),
                    /*#__PURE__*/ _jsx(MobileDrawer, {})
                ]
            }),
            /*#__PURE__*/ _jsx(Effects, {
                meta: meta,
                router: router
            })
        ]
    }));
};
App.getInitialProps = (function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(ctx) {
        var props, meta;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    props = NextApp.getInitialProps(ctx);
                    _ctx.next = 3;
                    return cms().websiteSeoTags();
                case 3:
                    meta = _ctx.sent;
                    return _ctx.abrupt("return", _objectSpread({}, props, {
                        meta: meta
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
